// Needed only during development for some reason. More info on github issue
// import 'firebase/auth';
import 'firebase/compat/auth';

import { Injectable } from '@angular/core';
import { Auth, authState, signInWithCustomToken, User,  } from "@angular/fire/auth";
import { HttpClient } from '@angular/common/http';
import { switchMap, map } from 'rxjs/operators';
import { Observable, from } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  user$: Observable<User>;
  user: User;

  // Is auth status initializing
  pending: boolean = true;

  constructor(
    private afAuth: Auth,
    private http: HttpClient,
  ) {
    this.user$ = authState(this.afAuth);
    this.user$.subscribe(user => {
      this.user = user;
      this.pending = false;
    }, err => {
      this.logout();
    });
  }

  login(token: string) {
    return this.http.post<{ token: string }>(`${environment.authURL}/authenticate`, { token })
      .pipe(
        switchMap(result => from(signInWithCustomToken(this.afAuth, result.token)))
      );
  }

  logout() {
    this.pending = true;
    return this.afAuth.signOut();
  }

}
